import React, { useState } from 'react'
import { Box, TextField, Typography, ClickAwayListener, Checkbox, FormControlLabel, FormGroup, IconButton, Button } from '@mui/material'
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material'
import { useSurveyStore } from '../../surveyutilities/surveyStore'

function MultipleChoiceBlock({ block, position }) {
    const [editingTitle, setEditingTitle] = useState(false);
    const [editingDescription, setEditingDescription] = useState(false);
    const updateQuestion = useSurveyStore((state) => state.updateQuestion);

    const handleTitleClick = () => setEditingTitle(true);
    const handleDescriptionClick = () => setEditingDescription(true);
    const handleClickAway = () => {
        setEditingTitle(false);
        setEditingDescription(false);
    };

    const handleTitleChange = (event) => {
        updateQuestion(block.internalId, { title: event.target.value });
    };

    const handleDescriptionChange = (event) => {
        updateQuestion(block.internalId, { description: event.target.value });
    };

    const handleOptionChange = (optionId, newText) => {
        const updatedOptions = block.options.map(opt =>
            opt.id === optionId ? { ...opt, text: newText } : opt
        );
        updateQuestion(block.internalId, { options: updatedOptions });
    };

    const addOption = () => {
        const newOption = {
            id: `opt_${Date.now()}`,
            text: `Option ${block.options.length + 1}`,
            value: `option_${block.options.length + 1}`
        };
        updateQuestion(block.internalId, { options: [...block.options, newOption] });
    };

    const removeOption = (optionId) => {
        if (block.options.length > 1) {
            updateQuestion(block.internalId, {
                options: block.options.filter(opt => opt.id !== optionId)
            });
        }
    };

    return (
        <Box>
            <ClickAwayListener onClickAway={handleClickAway}>
                <Box>
                    {editingTitle ? (
                        <TextField
                            autoFocus
                            fullWidth
                            value={block.title}
                            onChange={handleTitleChange}
                            onBlur={handleClickAway}
                            variant="outlined"
                            sx={{ mb: 1 }}
                        />
                    ) : (
                        <Typography
                            sx={{ mb: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
                            onClick={handleTitleClick}
                        >
                            {position + 1}. {block.title} {block.required ? <span style={{color: 'red'}}>*</span> : ''}
                        </Typography>
                    )}

                    {editingDescription ? (
                        <TextField
                            autoFocus
                            fullWidth
                            value={block.description}
                            onChange={handleDescriptionChange}
                            onBlur={handleClickAway}
                            variant="outlined"
                            multiline
                            maxRows={4}
                            sx={{ mb: 1 }}
                        />
                    ) : (
                        <Typography
                            variant="body2"
                            sx={{ mb: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
                            onClick={handleDescriptionClick}
                        >
                            {block.description}
                        </Typography>
                    )}

                    <FormGroup>
                        {block.options.map((option) => (
                            <Box key={option.id} sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                                <Checkbox disabled />
                                <TextField
                                    value={option.text}
                                    onChange={(e) => handleOptionChange(option.id, e.target.value)}
                                    variant="standard"
                                    fullWidth
                                    sx={{ ml: 1 }}
                                />
                                {block.options.length > 1 && (
                                    <IconButton
                                        size="small"
                                        onClick={() => removeOption(option.id)}
                                        sx={{ ml: 1 }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </Box>
                        ))}
                    </FormGroup>

                    <Button 
                        onClick={addOption} 
                        sx={{ mt: 1 }}
                        startIcon={<AddIcon />}
                        variant="text"
                        size="small"
                    >
                        Add Option
                    </Button>
                </Box>
            </ClickAwayListener>
        </Box>
    );
}

export default MultipleChoiceBlock;